// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarChatBox_container__GmcOY {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
}

.SideBarChatBox_new_chat_box__uv1h1 {
    width: 100%;
    height: 40px;
    padding: 0 17px;
}

.SideBarChatBox_progress_bar__Rp8uQ {
    width: 100%;
    /* height: 40px; */
    padding: 0 17px;
    margin-top: 10px;
}

.SideBarChatBox_chat_type_box__sUIgj {
    width: 100%;
    /* min-height: 45px; */
    /* max-height: 225px; */
    padding: 0 17px;
    margin-top: 10px;
}

.SideBarChatBox_divider_box__sjoik {
    /* height: 26px; */
    width: 100%;
    padding: 0 17px;
}

.SideBarChatBox_chat_history_box__l0gqC {
    width: 100%;
    /* max-height: calc(100% - 40px - 40px - 10px - 225px - 10px - 26px); */
    /* min-height: calc(100% - 40px - 40px - 10px - 45px - 10px - 26px); */
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 17px;
}

.SideBarChatBox_chat_history_box__l0gqC::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.SideBarChatBox_chat_history_box__l0gqC::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: rgba(193, 193, 193, .5);
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.SideBarChatBox_chat_history_box__l0gqC::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.SideBarChatBox_count_container__D7wV6 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    padding-left: 10px;
    margin-bottom: 5px;
    border-radius: 6px;
    -webkit-user-select: none;
    user-select: none;
}

.SideBarChatBox_count_text__MQUjP {
    font-size: 14px;
    color: #e7e7e7;
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarChatBox/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uEAAuE;IACvE,sEAAsE;IACtE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,4DAAsC,UAAU;IAC5C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,kEAA4C,WAAW;IACnD,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IAEnC,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.new_chat_box {\n    width: 100%;\n    height: 40px;\n    padding: 0 17px;\n}\n\n.progress_bar {\n    width: 100%;\n    /* height: 40px; */\n    padding: 0 17px;\n    margin-top: 10px;\n}\n\n.chat_type_box {\n    width: 100%;\n    /* min-height: 45px; */\n    /* max-height: 225px; */\n    padding: 0 17px;\n    margin-top: 10px;\n}\n\n.divider_box {\n    /* height: 26px; */\n    width: 100%;\n    padding: 0 17px;\n}\n\n.chat_history_box {\n    width: 100%;\n    /* max-height: calc(100% - 40px - 40px - 10px - 225px - 10px - 26px); */\n    /* min-height: calc(100% - 40px - 40px - 10px - 45px - 10px - 26px); */\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding: 0 17px;\n}\n\n.chat_history_box::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.chat_history_box::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: rgba(193, 193, 193, .5);\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.chat_history_box::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.count_container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n    padding-left: 10px;\n    margin-bottom: 5px;\n    border-radius: 6px;\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n.count_text {\n    font-size: 14px;\n    color: #e7e7e7;\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideBarChatBox_container__GmcOY`,
	"new_chat_box": `SideBarChatBox_new_chat_box__uv1h1`,
	"progress_bar": `SideBarChatBox_progress_bar__Rp8uQ`,
	"chat_type_box": `SideBarChatBox_chat_type_box__sUIgj`,
	"divider_box": `SideBarChatBox_divider_box__sjoik`,
	"chat_history_box": `SideBarChatBox_chat_history_box__l0gqC`,
	"count_container": `SideBarChatBox_count_container__D7wV6`,
	"count_text": `SideBarChatBox_count_text__MQUjP`
};
export default ___CSS_LOADER_EXPORT___;
